export function toTitleCase(str) {
  if (!str) return str;

  const exceptions = [
    "a",
    "ante",
    "bajo",
    "cabe",
    "con",
    "contra",
    "de",
    "desde",
    "durante",
    "en",
    "entre",
    "hacia",
    "hasta",
    "mediante",
    "para",
    "por",
    "según",
    "sin",
    "sobre",
    "tras",
    "versus",
    "vía",
    "el",
    "la",
    "los",
    "las",
    "y",
    "o",
  ];

  return str
    .split(" ")
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index === 0 || !exceptions.includes(lower)) {
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      } else {
        return lower;
      }
    })
    .join(" ");
}

/**
 * Formatea un valor numérico con decimales controlados.
 *
 * @param {string} value - Valor a evaluar.
 * @param {number} decimals - Cantidad de decimales requeridos.
 * @param {"string" | "number"} [returnType="string"] - Tipo de retorno.
 * @returns {string | number} - Valor formateado o "" si es inválido.
 */
export function formatNumber(value, decimals, returnType = "string") {
  try {
    if (typeof value !== "string") return "";

    const trimmed = value.trim();

    if (trimmed === "") return "";

    // Validación estricta de número (enteros y decimales, positivos y negativos)
    const isNumeric = /^-?\d+(\.\d+)?$/.test(trimmed);
    if (!isNumeric) return "";

    const num = Number(trimmed);

    if (!Number.isFinite(num)) return "";

    const fixed = num.toFixed(decimals);

    if (returnType === "number") {
      return Number(fixed);
    }

    return fixed; // string por defecto
  } catch {
    return "";
  }
}
